import vehicleService from "../../service/vehicle.service";

/**
 * Extrai vehicleId do ponteiro fino (ou snapshot legado) em allData.vehicle.
 */
export function getDriverVehicleId(allDataOrVehicle) {
  if (!allDataOrVehicle) return "";
  const pointer =
    allDataOrVehicle.vehicle !== undefined
      ? allDataOrVehicle.vehicle
      : allDataOrVehicle;
  return String(pointer?.vehicleId ?? "").trim();
}

/**
 * Fallback legado: snapshot embutido sem documento na coleção vehicle.
 */
export function mapLegacyDriverVehicleSnapshot(pointer) {
  if (!pointer?.vehiclePlate) return null;
  return {
    id: pointer.vehicleId || undefined,
    vehiclePlate: pointer.vehiclePlate,
    bodyworkPlate: pointer.bodyworkPlate || "",
    bodyworkType: pointer.bodyworkType || "",
    capacidadeKG: pointer.capacidadeKG || "",
    capacidadeM3: pointer.capacidadeM3 || "",
    cpfoucnpj: pointer.cpfoucnpj || "",
    descricaoVeiculo: pointer.descricaoVeiculo || "",
    nomeProprietario: pointer.nomeProprietario || "",
    pesoTara: pointer.pesoTara || "",
    reboques: Array.isArray(pointer.reboques) ? pointer.reboques : [],
    renavam: pointer.renavam || "",
    rntrc: pointer.rntrc || "",
    tipoProprietario: pointer.tipoProprietario || "",
    tipoRNTRC: pointer.tipoRNTRC || "",
    ufVeiculo: pointer.ufVeiculo || "",
    vehicleImg: pointer.vehicleImg || "",
    vehicleType: pointer.vehicleType || "",
    veiculoProprio: pointer.veiculoProprio ?? false,
    documentCRLV: pointer.documentCRLV || "",
    documentAnttFrontImg: pointer.documentAnttFrontImg || "",
  };
}

/**
 * Resolve veículo do motorista pela coleção vehicle (fonte de verdade).
 * Aceita driverUid e, opcionalmente, allData já carregado para fallback legado.
 */
export async function resolveVehicleForDriver(driverUid, allData) {
  const uid = String(driverUid || "").trim();
  if (uid) {
    try {
      const vehicle = await vehicleService.getByDriverUid(uid);
      if (vehicle) return vehicle;
    } catch (error) {
      console.warn(
        "[resolveVehicleForDriver] falha getByDriverUid",
        uid,
        error,
      );
    }
  }

  const pointer = allData?.vehicle ?? null;
  const vehicleId = getDriverVehicleId(pointer);
  if (vehicleId) {
    try {
      const response = await vehicleService.getById(vehicleId);
      const vehicle = response?.data?.data ?? response?.data ?? null;
      if (vehicle) return vehicle;
    } catch (error) {
      console.warn(
        "[resolveVehicleForDriver] falha getById",
        vehicleId,
        error,
      );
    }
  }

  return mapLegacyDriverVehicleSnapshot(pointer);
}

/**
 * Resolve veículos para vários motoristas (batch na API).
 * @returns {Promise<Map<string, object|null>>}
 */
export async function resolveVehiclesForDrivers(driverUids) {
  const map = await vehicleService.getByDriverUids(driverUids);
  return new Map(Object.entries(map || {}));
}

/**
 * Batch por vehicleIds → Map(id → vehicle).
 */
export async function resolveVehiclesByIds(vehicleIds) {
  const list = await vehicleService.getByIds(vehicleIds);
  return new Map((list || []).map((item) => [String(item.id), item]));
}
